import React from "react";

import { BarChart2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const FinanceChartEmpty = ({ height = 320 }) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col justify-center items-center text-gray-500"
      style={{ height: `${height}px` }}
    >
      <BarChart2 className="w-12 h-12 mb-2 text-gray-300" aria-hidden="true" />
      <p className="font-medium">{t("finance:no_chart_data")}</p>
      <p className="text-sm text-gray-400">
        {t("finance:try_different_date_range")}
      </p>
    </div>
  );
};

export default FinanceChartEmpty;
